const EventBus = {
  listeners: {},

  on(event, fn) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(fn);
  },

  off(event, fn) {
    this.listeners[event] =
      (this.listeners[event] || []).filter(f => f !== fn);
  },

  emit(event, data) {
    (this.listeners[event] || []).forEach(fn => fn(data));
  },
};

export default EventBus;
